import { Box } from '@chakra-ui/react'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts'
import { useChartTheme } from '../../../hooks/useChartTheme'
import CustomTooltip from './CustomTooltip'
import { brand } from '../../../theme'
import type { SupplierRanking } from '../../../data/mockEstadisticas'

interface SupplierRankingChartProps {
  data: SupplierRanking[]
}

export default function SupplierRankingChart({ data }: SupplierRankingChartProps) {
  const { axis, grid } = useChartTheme()

  const chartData = data.map((s) => ({
    nombre: s.nombre.length > 20 ? s.nombre.slice(0, 20) + '...' : s.nombre,
    tonelaje: s.tonelaje,
    porcentaje: s.porcentaje,
  }))

  return (
    <Box h="360px">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={chartData} layout="vertical" margin={{ left: 20, right: 20 }}>
          <CartesianGrid stroke={grid.stroke} strokeDasharray={grid.strokeDasharray} horizontal={false} />
          <XAxis type="number" stroke={axis.stroke} tick={axis.tick} tickFormatter={(v: number) => `${(v / 1000).toFixed(0)}k TM`} />
          <YAxis type="category" dataKey="nombre" stroke={axis.stroke} tick={axis.tick} width={150} />
          <Tooltip content={<CustomTooltip formatter={(v) => `${v.toLocaleString()} TM`} />} />
          <Bar dataKey="tonelaje" name="Tonelaje" radius={[0, 4, 4, 0]} barSize={20}>
            {chartData.map((_, index) => (
              <Cell
                key={index}
                fill={index === 0 ? brand.green : index === 1 ? brand.greenLight : `${brand.green}88`}
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </Box>
  )
}
